import { gql } from '@apollo/client';

export const GET_SITE_VISIT = gql`
  query GetSiteVisit($id: ID!) {
    siteVisit(id: $id) {
      id
      userId
      title
      map {
        address
        coordinates
        city
        state
        county
      }
      preview {
        id
        isPublish
        isPrimary
        original
        compressed
        size
        type
      }
      categories {
        id
        title
        description
        type
        icon
        questions {
          id
          title
          description
          type
          category
          required
          help
          helpImages
          mapType
          colors {
            point
            line
            fill
          }
          mode
          options
          result
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const ADMIN_SITE_VISIT_LIST = gql`
  query AdminSiteVisitList {
    siteVisitAdminList {
      id
      userId
      title
      map {
        address
        coordinates
        city
        state
      }
      preview {
        id
        original
        compressed
      }
      createdAt
      updatedAt
    }
  }
`;

export const USER_SITE_VISIT_LIST = gql`
  query UserSiteVisitList($userId: String!) {
    siteVisitUserList(userId: $userId) {
      id
      title
      map {
        address
        coordinates
        city
        state
      }
      preview {
        id
        original
        compressed
      }
      createdAt
      updatedAt
    }
  }
`;
